import { useRecoverOrderPayment } from "@/api/orders";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { useSession } from "@/services/auth0/session";

export function RecoverOrderPaymentButton({
  orderId,
  shipmentId,
}: {
  orderId: string;
  shipmentId: string;
}) {
  const { token } = useSession();
  const recovery = useRecoverOrderPayment(orderId, shipmentId);
  const pending = recovery.isPending;
  const recover = async () => {
    if (pending) return;
    try {
      const { status, data } = await recovery.mutateAsync();
      if (status === 202)
        toast.info(
          data.message ??
            "Payment confirmation is still pending. No new charge was made."
        );
      else if (data.preparationStatus === "COMPLETE")
        toast.success("Payment confirmed; preparation complete");
      else throw new Error("Preparation is not complete");
    } catch (error) {
      const message = axios.isAxiosError<{ error?: string; message?: string }>(
        error
      )
        ? (error.response?.data.message ?? error.response?.data.error)
        : undefined;
      toast.error(
        message ??
          "Could not recover payment and preparation. Please retry or investigate the payment."
      );
    }
  };
  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className="h-auto min-h-11 w-full max-w-full whitespace-normal md:h-8 md:min-h-8 md:w-auto md:whitespace-nowrap"
      disabled={pending || !token}
      onClick={() => void recover()}
      title="Checks an existing payment and retries preparation. Does not charge the customer."
    >
      {pending ? "Checking payment…" : "Check payment & retry preparation"}
    </Button>
  );
}
